<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Nueva Notificación</v-toolbar-title>
    </v-toolbar>
    <div class="spacing-top">
      <v-card>
        <v-alert :value="customErrorPresent" type="error">{{customErrorMessage}}</v-alert>
        <v-card-text>
          <form>
            <v-layout row wrap>
              <v-flex xs6 pr-2>
                <v-text-field v-model="title" :error-messages="titleErrors" label="Título"
                              required @input="$v.title.$touch()"></v-text-field>
              </v-flex>
              <v-flex xs4 px-2>
                <DatePickerForm v-model="expiration" label="Fecha de vencimiento (opcional)" clearable></DatePickerForm>
              </v-flex>
              <v-flex xs2 pl-2>
                <v-select v-model="urgencySelected" :items="urgencyLevels" label="Nivel de urgencia" item-text="display"
                          item-value="pk" no-data-text="No hay datos disponibles"></v-select>
              </v-flex>
            </v-layout>
            <v-textarea v-model="message" :error-messages="messageErrors" label="Mensaje"
                        required @input="$v.message.$touch()"></v-textarea>
            <v-layout row wrap>
              <v-flex xs12>
                <SelectItems v-model="categorias" :items="categoriasNames" itemText="description" itemValue="id"
                             label="Categorías" :loading="loadingGrupos"></SelectItems>
              </v-flex>
              <v-flex xs6 pr-2>
                <SelectItems v-model="personas" :items="personasNames" itemText="nombre" itemValue="id"
                             label="Grupo de personas" :loading="loadingCategorias"></SelectItems>
              </v-flex>
              <v-flex xs6 pl-2>
                <SelectItems v-model="clubes" :items="clubesNames" itemText="nombre" itemValue="pk"
                             label="Clubes" :loading="loadingClubs"></SelectItems>
              </v-flex>
              <v-flex xs12>
                <SelectItems v-model="grupos" :items="gruposNames" itemText="nombre" itemValue="id"
                             label="Grupos predeterminados" :loading="loadingGrupos"></SelectItems>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <EmailCombobox ref="emails"></EmailCombobox>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="submit" color="primary">Crear</v-btn>
            </v-card-actions>
          </form>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { recipientsMixin } from '../../../mixins/recipientsMixin'
import SelectItems from '../../../common/ui/SelectItems'
import EmailCombobox from '../../../common/ui/EmailCombobox'
import DatePickerForm from '../../../common/ui/DatePickerForm'

export default {
  mixins: [recipientsMixin],

  components: {
    SelectItems,
    EmailCombobox,
    DatePickerForm
  },

  data () {
    return {
      apiPath: '/notification/new',
      routerPath: 'notificaciones',
      loadingUrgency: true,
      urgencyLevels: [],
      urgencySelected: 1,
      expiration: null,
      fetchClubsOnCategorySelection: true
    }
  },

  methods: {
    fetchUrgencyLevels () {
      this.axios
        .get('notifications/urgency_levels')
        .then(response => {
          this.urgencyLevels = response.data
          this.loadingUrgency = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getPayload () {
      return {
        title: this.title,
        message: this.message,
        definicionesCriterio: this.personas,
        clubes: this.clubes,
        grupos: this.grupos,
        emails: this.$refs.emails.getEmails(),
        urgency: this.urgencySelected,
        expiration: this.expiration
      }
    }
  },

  created () {
    this.fetchData()
    this.fetchUrgencyLevels()
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em !important;
  }
  .toolbar-element {
    background: linear-gradient(#e2e2e2, #cbd1db);
  }
  .toolbar-title {
    font-size: 2.2em;
    font-family: SourceSansProLight, sans-serif;
    color: #293968;
  }
</style>
